const initialState = {
    fetchingUsers: false,
    fetchingInterests: false,
    fetchingInterestsContent: false,
    fetchingTags: false,
    wasSaved: false,
    isEditing: false,
    edit: false,
    data: {
        users: [],
        interests: [],
        interestsContent: [],
        tags: [],
        selectedTag: null,
        interest: null,
        interestContent: null,
        lists: [],
        products: [],
        user: {},
    },
};

export default function admin(state = initialState, action) {
    let tags;

    switch (action.type) {
        case 'ADMIN_GET_USERS':
            return {
                ...state,
                fetchingUsers: true,
            };
        case 'ADMIN_RECEIVE_USERS':
            return {
                ...state,
                fetchingUsers: false,
                data: {
                    ...state.data,
                    users: action.users,
                },
            };
        case 'ADMIN_GET_INTERESTS':
            return {
                ...state,
                fetchingInterests: true,
            };
        case 'ADMIN_RECEIVE_INTERESTS':
            return {
                ...state,
                fetchingInterests: false,
                data: {
                    ...state.data,
                    interests: action.interests,
                },
            };
        case 'ADMIN_RECEIVE_UPDATED_INTEREST':
            var updatedInterest = action.interest;
            var interests = state.data.interests.asMutable();
            for( let i = 0; i < interests.length; i++ ) {
                if( updatedInterest.interestid == interests[ i ].interestid ) {
                    interests[ i ] = updatedInterest;
                    break;
                }
            }
            return {
                ...state,
                fetchingInterests: false,
                data: {
                    ...state.data,
                    interests: interests,
                },
            };
        case 'ADMIN_GET_INTERESTS_CONTENT':
            return {
            ...state,
            fetchingInterestsContent: true,
            };
        case 'ADMIN_RECEIVE_INTERESTS_CONTENT':
            return {
            ...state,
            fetchingInterestsContent: false,
            data: {
                ...state.data,
                interestsContent: action.interestsContent,
            },
            };
        case 'ADMIN_RECEIVE_LISTS':
            return {
            ...state,
            data: {
                ...state.data,
                lists: action.lists,
            },
            };
        case 'ADMIN_RECEIVE_PRODUCTS':
            return {
            ...state,
            data: {
                ...state.data,
                products: action.products,
            },
            };
        case 'ADMIN_SELECT_USER':
            return {
            ...state,
            data: {
                ...state.data,
                user: action.user,
                lists: [],
                products: [],
            },
            };
        case 'ADMIN_SELECT_INTEREST':
            return {
            ...state,
            data: {
                ...state.data,
                interest: action.interest,
                interestsContent: [],
            },
            };

        case 'ADMIN_GET_TAGS':
            return {
            ...state,
            fetchingTags: true,
            };
        case 'ADMIN_RECEIVE_TAGS':
            return {
            ...state,
            fetchingTags: false,
            data: {
                ...state.data,
                tags: action.tags,
            },
            };
        case 'ADMIN_SELECT_TAG':
            return {
            ...state,
            data: {
                ...state.data,
                selectedTag: action.tag,
            },
            };
        case 'ADMIN_RECEIVE_UPDATED_TAG':
            var updatedTag = action.tag;
            tags = state.data.tags.asMutable();
            for( let i = 0; i < tags.length; i++ ) {
                if( updatedTag.tagid == tags[ i ].tagid ) {
                    tags[ i ] = updatedTag;
                    break;
                }
            }
            return {
                ...state,
                fetchingTags: false,
                data: {
                    ...state.data,
                    tags: tags,
                    selectedTag: updatedTag,
                },
            };
        case 'ADMIN_REMOVE_TAG':
            var tagid = action.tagid;
            tags = state.data.tags.asMutable();
            for( var i = 0; i < tags.length; i++ ) {
                if( tagid == tags[ i ].tagid ) {
                    tags.splice( i, 1 );
                    break;
                }
            }
            return {
                ...state,
                fetchingTags: false,
                data: {
                    ...state.data,
                    tags: tags,
                },
            };
        default:
            return state;
    }
}
